<!-- Header -->
<div class="modal-header">
  <h3 class="modal-title">
    <strong>{{ mode === 'lock' ? 'Lock Tags' : 'Unlock Tags' }}</strong>
  </h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise = !minimise"></i>
    <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
  </div>
</div>

<!-- Warning Banner -->
@if (warningMessage) {
<div class="warning-msg-class">
  <strong>{{ warningMessage }}</strong>
</div>
}

<!-- Body -->
<div class="row" [hidden]="minimise" style="margin-top: 15px;">
  <div class="col-md-12">
    <div class="table-scroll" style="padding-top: 0 !important;">
      <table class="main-table">
        <thead>
          <tr>
            <th class="sticky-col"></th>
            <th class="sticky-col">Warning</th>
            <th class="sticky-col">LEID</th>
            <th class="sticky-col">Tax Code</th>
            <th class="sticky-col">Reporting Period</th>
            <th class="sticky-col">ME Code</th>
            <th class="sticky-col">Gross Inc/Exp</th>
            <th class="sticky-col">Transaction Category</th>
            <th class="sticky-col">Basket</th>
            <th class="sticky-col">FDII</th>
            <th class="sticky-col">SIC Code</th>
            <th class="sticky-col">Notes</th>
            <th class="sticky-col">Source Type</th>
            <th class="sticky-col">Project Tagging</th>
            <th class="sticky-col">BEAT</th>
            <th class="sticky-col">BEAT Type</th>
            <th class="sticky-col">Related/Unrelated</th>
            <th class="sticky-col">Trading Partner</th>
            <th class="sticky-col">Country</th>
            <th class="sticky-col">HTKO</th>
            <th class="sticky-col">FSI</th>
            <th class="sticky-col">Method</th>
            <th class="sticky-col">Base FDII</th>
            <th class="sticky-col">Base Basket</th>
            <th class="sticky-col">Base Type</th>
            <th class="sticky-col">Base Level</th>
            <th class="sticky-col">Base Entity Level</th>
          </tr>
        </thead>
        <tbody>
          @for (t of lockUnlockSelected; track $index) {
<tr>
            <td>
              <i class="fa fa-times" style="cursor: pointer;"
                 (click)="removeLockUnLockRow(t)"></i>
            </td>
            <td [ngClass]="{'warning-class': isRowWarning(t), 'default-color': !isRowWarning(t)}">
              @if (isRowWarning(t)) {
<span>{{ getRowWarningText(t) }}</span>
}
            </td>
            <td>{{ t.LEID }}</td>
            <td>{{ t.CDR_NO }}</td>
            <td>{{ t.REPORTING_PERIOD }}</td>
            <td>{{ t.ME_CODE }}</td>
            <td>{{ t.GROSS_INC_EXP }}</td>
            <td>{{ t.TRANS_CATG_NAME }}</td>
            <td>{{ t.BASKET_0 }}</td>
            <td>{{ t.FDII_0 }}</td>
            <td>{{ t.SIC_CODES_0 }}</td>
            <td>{{ t.NOTES_0 }}</td>
            <td>{{ t.SOURCE_TYPE_0 }}</td>
            <td>{{ t.PROJECT_TAGGING_0 }}</td>
            <td>{{ t.BEAT_0 }}</td>
            <td>{{ t.BEAT_TYPE_0 }}</td>
            <td>{{ t.RELATED_UNRELATED_0 }}</td>
            <td>{{ t.TP_ME_KEY_0 }}</td>
            <td>{{ t.COUNTRY_0 }}</td>
            <td>{{ t.HTKO_0 }}</td>
            <td>{{ t.FSI_0 }}</td>
            <td>{{ t.METHOD_0 }}</td>
            <td>{{ t.BASE_FDII_0 }}</td>
            <td>{{ t.BASE_BASKET_0 }}</td>
            <td>{{ t.BASE_TYPE_0 }}</td>
            <td>{{ t.BASE_LEVEL_0 }}</td>
            <td>{{ t.BASE_ENTITY_LEVEL_0 }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button"
          (click)="save()"
          [disabled]="warningExists || isSaveClicked">
    Save
  </button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
